// extracted by mini-css-extract-plugin
export default {"zoomModal":"f4-z","image":"g4-z","button":"h4-z","isOverlayShown":"i4-z"};